








import { Vue, Component, Prop, Watch } from "vue-property-decorator";

// Enums
import { SortableItems } from "@/data/enums/sortableItems";

// Types
import { ISelectedProduct } from "@/models/products";

@Component({
  components: {
    "select-categories": () =>
      import(
        "@/components/app/admin/catalogue/products/multilevelCategories/selectCategories.vue"
      )
  }
})
export default class SelectProductCategory extends Vue {
  // Props
  @Prop({ default: null })
  public selectedId!: string | null;

  // Data
  public selectedCategories: ISelectedProduct[] = [];
  public initiated = false;

  public created() {
    if (!this.selectedId) {
      this.initiated = true;
      return;
    }

    this.selectedCategories.push({
      id: this.selectedId,
      name: "",
      object_type: SortableItems.CATEGORY
    });
  }

  @Watch("selectedCategories")
  public onSelectedCategoriesChange() {
    const selectedId = this.$_.get(this.selectedCategories, "[0].id", null);

    if (!this.initiated) {
      this.initiated = true;
      return;
    } else {
      this.$emit("select", selectedId);
    }
  }
}
